import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "q-row" }
const _hoisted_2 = {
  key: 0,
  class: "popular-products__header q-col-md-12 q-text-muted q-fw-semibold"
}

import SingleProduct from './SingleProduct.vue'

import {storeToRefs} from "pinia";

import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsList',
  props: ['productsList', 'productsHeader', 'promotedProductEnabled', 'canShowPromotedSection'],
  setup(__props) {



const popupStore = usePopupStore()

const filtersStore = useFiltersStore();
const {isMobileView} = storeToRefs(filtersStore)




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["q-col-12", {'q-col-12 q-col-md-9 q-ps-1': __props.promotedProductEnabled && __props.canShowPromotedSection,'q-col-12': !__props.promotedProductEnabled && !__props.canShowPromotedSection}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(isMobileView))
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.productsHeader), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.productsList, (result) => {
        return (_openBlock(), _createBlock(SingleProduct, {
          result: result,
          key: result.id
        }, null, 8, ["result"]))
      }), 128))
    ])
  ], 2))
}
}

})